var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "datepicker" },
    [
      _c(
        "div",
        {
          staticClass: "datepicker-visible-temp-date",
          on: { click: _vm.clickOnTempDate },
        },
        [_vm._v(_vm._s(_vm.visibleTempDate))]
      ),
      _vm._v(" "),
      _c("datepicker", {
        ref: "datepicker",
        attrs: {
          date: _vm.visibleData,
          option: _vm.option,
          disabled: _vm.disabled,
          limit: _vm.actualLimit,
        },
        on: { change: _vm.visibleDataChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }